import { Container } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import styled from "@emotion/styled";

//images
// import bgpattern from "assets/images/background-pattern.svg";
import bgpattern from "assets/images/home-page-images/Rectangle2.png";
// import bgpattern1 from "assets/images/home-page-images/image2.png";
// import bgpattern1 from "assets/images/home-page-images/image450.png";
import bgpattern1 from "assets/images/home-page-images/image400.png";

import User from "assets/images/home-page-images/RAAd2.png";
import Group6 from "assets/images/home-page-images/Group6.png";
import Group7 from "assets/images/home-page-images/Group7.png";
import Group8 from "assets/images/home-page-images/Group8.png";
import Vector2 from "assets/images/home-page-images/Vector2.png";
import HoverVector from "assets/images/home-page-images/HoverVector.png";
import MobBanner from "assets/images/home-page-images/MobBanner.png";

import tickIcon from "assets/images/small-logos/blue-tick.svg";
import dashboardHero from "assets/images/center-img.png";
import sparkles from "assets/images/small-logos/sparkles.svg";
import socialicons from "assets/images/social-group.png";
import zIndex from "@mui/material/styles/zIndex";
import { Margin } from "@mui/icons-material";
import MDButton from "components/MDButton";
import { useState } from "react";
import { NavLink } from "react-router-dom";

const BannerText = styled.p`
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
  text-align: left;
  color: #707070;
`;

function MainSection() {
  const [hovered, setHovered] = useState(false);

  return (
    <MDBox
      sx={{
        width: "100%",
        maxWidth: {
          xs: "100%",
          md: "1580px",
          xl: "1920px",
        },
        mx: "auto",
        // px: 2,
      }}
    >
      <MDBox
        sx={{
          height: {
            xs: "339px",
            sm: "fit-content",
            md: "fit-content",
          },

          background: {
            xs: "linear-gradient(180.13deg, #FFFFFF 0%, #318BEC 99.48%)",
            sm: "linear-gradient(179.93deg, #FFFFFF 18.61%, #318BEC 59.48%)",
            md: "linear-gradient(179.93deg, #FFFFFF 18.61%, #318BEC 59.48%)",
          },

          position: "relative",
          marginTop: {
            xs: "50px",
            md: "94px",
            xl: "94px",
          },
        }}
      >
        <MDBox
          sx={{
            position: "absolute",
            bottom: {
              xs: -80,
              sm: -225,
              md: -225,
            },
            left: 0,
            zIndex: 0,
          }}
        >
          <MDBox
            component="img"
            src={bgpattern1}
            alt="background"
            sx={{
              width: {
                xs: "430px",
                sm: "95%",
                md: "100%",
              },

              height: {
                xs: "171px",
                sm: "657px",
                md: "613px",
              },
            }}
          />{" "}
        </MDBox>

        <MDBox sx={{ width: "100%", margin: "auto" }}>
          <MDBox>
            <MDBox
              sx={{
                pt: {
                  xs: 2,
                  sm: 13,
                },
                display: "flex",
                alignItems: "start",
                justifyContent: {
                  xs: "start",
                  sm: "center",
                  md: "center",
                },

                textAlign: "center!important",
              }}
            >
              <MDBox
                sx={{
                  width: {
                    xs: "55%",
                    sm: "40%",
                  },
                  pl: {
                    xs: "2%",
                    sm: "4%",
                    md: "6.4%",
                  },
                  zIndex: 1,
                  display: "flex",
                  alignItems: "start",
                  justifyContent: "start",
                  flexDirection: "column",
                  "@media (min-width:475px)": { width: "90%" },
                  // width: "100%",
                  textAlign: "start",
                  "@media (max-width:576px)": { textAlign: "left" },
                }}
              >
                <MDBox
                  sx={{
                    "@media (min-width:336px)": { width: "90%" },
                    "@media (min-width:1500px)": { Width: "90%" },
                    marginBottom: "36px",
                    "@media (max-width:576px)": {
                      marginTop: "32px",
                      alignSelf: "center",
                      justifySelf: "center",
                    },
                    "@media(min-width:1400px)": { padding: "0 180px" },
                    "@media(min-width:1500px)": { padding: "0 60px" },
                    "@media(min-width:1580px)": { padding: "0 200px" },
                    "@media(max-width:576px)": { padding: "0 0px" },
                    "@media(min-width:993px)": { width: "100%" },
                  }}
                >
                  <MDTypography
                    variant="h1"
                    fontWeight="medium"
                    sx={{
                      color: "#318BEC",
                      fontFamily: "Poppins",
                      fontWeight: "400",
                      fontSize: "14px",
                      letterSpacing: "0.4px",
                      "@media (min-width:420px)": { fontSize: "12px" },
                      "@media (min-width:580px)": { fontSize: "18px" },
                      "@media (min-width:1500px)": { fontSize: "18px" },
                      marginTop: "0",
                    }}
                    my={1}
                  >
                    Empower Your Venue's Online Presence
                  </MDTypography>
                  <MDTypography
                    variant="h1"
                    fontWeight="medium"
                    sx={{
                      width: "100%",
                      color: "#000",
                      letterSpacing: "0.7px",
                      fontFamily: "Poppins",
                      fontWeight: 500,
                      // fontSize: "38px",
                      lineHeight: "48px",
                      "@media (min-width:300px)": {
                        fontSize: "15px",
                        lineHeight: "24px",
                        letterSpacing: "0.1px",
                        mb: 2,
                      },
                      "@media (min-width:580px)": {
                        width: "75%",
                        fontSize: "41px",
                        lineHeight: "58px",
                      },
                      "@media (min-width:1500px)": {
                        width: "80%",
                        fontSize: "60px",
                        lineHeight: "70px",
                      },
                      marginTop: "0",
                    }}
                    my={0}
                  >
                    #1 AI Growth Platform <br></br>for Restaurants, Cafés
                    <br></br> & Bars
                  </MDTypography>
                  <MDBox
                    sx={{
                      display: {
                        xs: "block",
                        sm: "none",
                        md: "none",
                      },
                      alignItems: "flex-start",
                      justifyContent: "flex-start",
                      marginBottom: "24px",
                      textAlign: "start",
                      position: "relative",
                    }}
                  >
                    {/* Mobile */}
                    <MDBox
                      component={NavLink}
                      to="/sign-up"
                      onMouseEnter={() => setHovered(true)}
                      onMouseLeave={() => setHovered(false)}
                      sx={{
                        width: "114px",
                        color: "#fff",
                        backgroundColor: "#318BEC",
                        padding: "6px 16px",
                        borderRadius: "4px",
                        fontSize: "10px",
                        fontWeight: 600,
                        lineHeight: "17px",
                        fontFamily: "urbanist",
                        textTransform: "none",
                        transition: "all 0.3s ease-in-out",
                        // "&:hover": {
                        //   background: "#318BEC",
                        // },
                      }}
                    >
                      Try Now for Free
                    </MDBox>
                  </MDBox>
                </MDBox>

                <MDBox
                  sx={{
                    display: {
                      xs: "none",
                      sm: "flex",
                      md: "flex",
                    },
                    alignItems: "start",
                    justifyContent: "center",
                    marginBottom: "24px",
                    width: "100%",
                    margin: "auto",
                    textAlign: "center",
                    "@media (min-width:786px)": { flexDirection: "row" },
                    flexDirection: "column",
                  }}
                >
                  <MDBox
                    sx={{
                      width: "350px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: {
                        xs: "center",
                        sm: "start",
                      },
                      justifyContent: "space-between",
                    }}
                    mr={2}
                    mb={2}
                  >
                    <MDBox sx={{ mr: 1, mb: 1, width: "52px", height: "52px" }}>
                      <img
                        src={Group7}
                        alt="tick icon"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                        }}
                      />
                    </MDBox>
                    <MDTypography
                      sx={{
                        // fontWeight: "800",
                        fontSize: "16px",
                        color: "#000",
                        fontFamily: "Poppins",
                      }}
                    >
                      {" "}
                      <MDBox
                        sx={{
                          fontWeight: 900,
                          color: "#000",
                          fontSize: "16px",
                        }}
                      >
                        Boost Review Score
                      </MDBox>
                    </MDTypography>
                    <MDTypography
                      varient="h3"
                      mb={2}
                      sx={{
                        fontWeight: 500,
                        textAlign: {
                          xs: "center",
                          sm: "start",
                        },
                        fontSize: {
                          xs: "18px",
                          sm: "13px",
                        },
                        color: "#000",
                        lineHeight: "18px",
                        fontFamily: "Poppins",
                        width: "90%",
                      }}
                    >
                      Monitor, Respond, and Drive 5-Star Ratings with More
                      Positive Reviews
                    </MDTypography>
                  </MDBox>

                  <MDBox
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: {
                        xs: "center",
                        sm: "start",
                      },
                      justifyContent: "space-between",
                    }}
                    mr={2}
                    mb={2}
                  >
                    <MDBox sx={{ mr: 1, mb: 1, width: "52px", height: "52px" }}>
                      <img
                        src={Group6}
                        alt="tick icon"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                        }}
                      />
                    </MDBox>
                    <MDTypography
                      sx={{
                        // fontWeight: "600",
                        fontSize: "16px",
                        color: "#000",
                        fontFamily: "Poppins",
                      }}
                    >
                      {" "}
                      <MDBox
                        sx={{
                          fontWeight: 900,
                          color: "#000",
                          fontSizq: "10px",
                        }}
                      >
                        Grow Revenue
                      </MDBox>
                    </MDTypography>

                    <MDTypography
                      mb={2}
                      sx={{
                        textAlign: {
                          xs: "center",
                          sm: "start",
                        },
                        fontSize: {
                          xs: "18px",
                          sm: "12px",
                        },
                        color: "#000",
                        fontWeight: "500",
                        lineHeight: "18px",
                        fontFamily: "Poppins",
                        width: "80%",
                      }}
                    >
                      Grow Revenue and Win Market Share with AI intelligence
                    </MDTypography>
                  </MDBox>

                  <MDBox
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: {
                        xs: "center",
                        sm: "start",
                      },
                      justifyContent: "space-between",
                    }}
                    mr={2}
                    mb={2}
                    mt={0}
                  >
                    <MDBox sx={{ mr: 1, mb: 1, width: "52px", height: "52px" }}>
                      <img
                        src={Group8}
                        alt="tick icon"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                        }}
                      />
                    </MDBox>
                    <MDTypography
                      sx={{
                        mb: 0.5,
                        // fontWeight: 700,
                        fontSize: "15px",
                        color: "#000",
                        fontFamily: "Poppins",
                      }}
                    >
                      {" "}
                      <MDBox
                        sx={{
                          fontWeight: 900,
                          color: "#000",
                          fontSizq: "10px",
                        }}
                      >
                        Grow Customer Base
                      </MDBox>
                    </MDTypography>
                    <MDTypography
                      mb={2}
                      sx={{
                        textAlign: {
                          xs: "center",
                          sm: "start",
                        },
                        fontSize: {
                          xs: "18px",
                          sm: "12px",
                        },
                        color: "#000",
                        lineHeight: "18px",
                        fontFamily: "Poppins",
                        width: "80%",
                      }}
                    >
                      Turn Neighbourhood Insights and Life Moments into Loyal
                      Customers
                    </MDTypography>
                  </MDBox>
                </MDBox>
                <MDBox sx={{ position: "relative" }}>
                  <MDBox
                    sx={{
                      display: {
                        xs: "none",
                        sm: "flex",
                        md: "flex",
                      },
                      alignItems: "flex-start",
                      justifyContent: "flex-start",
                      marginBottom: "24px",
                      textAlign: "start",
                      position: "relative",
                    }}
                  >
                    {/* Desktop  */}
                    <MDBox
                      component={NavLink}
                      to="/sign-up"
                      onMouseEnter={() => setHovered(true)}
                      onMouseLeave={() => setHovered(false)}
                      sx={{
                        mt: 1,
                        color: "#fff",
                        backgroundColor: "#318BEC",
                        padding: "12px 50px",
                        borderRadius: "10px",
                        fontSize: "20px",
                        fontWeight: 700,
                        fontFamily: "urbanist",
                        textTransform: "none",
                        transition: "all 0.3s ease-in-out",
                        "&:hover": {
                          background: "#F47C00",
                        },
                      }}
                    >
                      Try Now for Free
                      {/* <MDBox
                        sx={{
                          position: "absolute",
                          bottom: -17,
                          right: -12,
                          zIndex: 1,
                        }}
                      >
                        <img
                          src={hovered ? HoverVector : Vector2}
                          alt="vector"
                          style={{ width: "30px" }}
                        />
                      </MDBox> */}
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDBox>

              <MDBox
                sx={{
                  width: {
                    xs: "45%",
                    sm: "60%",
                  },
                  mt: {
                    xs: 0,
                    sm: 0,
                    md: -8,
                  },
                  mr: -2,
                  pt: 0,
                  boxShadow: " rgba(0,0,0,0.1)",
                  borderRadius: "8px",
                  zIndex: 2,
                }}
              >
                {/* desktop  */}
                <MDBox
                  component="img"
                  src={User}
                  alt="background"
                  sx={{
                    display: { xs: "none", sm: "block", md: "block" },
                    width: {
                      xs: "232px",
                      sm: "100%",
                    },

                    height: {
                      xs: "232px",
                      sm: "100%",
                      md: "100%",
                    },
                  }}
                />
                {/* Mobile  */}
                <MDBox
                  component="img"
                  src={MobBanner}
                  alt="background"
                  sx={{
                    display: { xs: "block", sm: "none", md: "none" },
                    width: {
                      xs: "232px",
                      sm: "100%",
                    },

                    height: {
                      xs: "232px",
                      sm: "100%",
                      md: "100%",
                    },
                  }}
                />
              </MDBox>
            </MDBox>
            {/* mobile Screen  */}
            <MDBox
              sx={{
                display: {
                  xs: "flex",
                  sm: "none",
                  md: "none",
                },
                zIndex: 2,
                alignItems: "start",
                justifyContent: "center",
                marginBottom: "24px",
                width: "100%",
                margin: "auto",
                textAlign: "center",
              }}
            >
              <MDBox
                sx={{
                  zIndex: 2,
                  width: "130px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: {
                    xs: "center",
                    sm: "start",
                  },
                  justifyContent: "space-between",
                }}
                mr={2}
                mb={2}
              >
                <MDBox>
                  <img
                    src={Group7}
                    alt="tick icon"
                    style={{
                      width: "38px",
                      height: "38px",
                      objectFit: "contain",
                    }}
                  />
                </MDBox>
                <MDTypography
                  sx={{
                    lineHeight: "17px",
                    fontSize: "10px",
                    color: "#000",
                    fontFamily: "Poppins",
                  }}
                >
                  {" "}
                  <MDBox
                    sx={{
                      fontWeight: 500,
                      color: "#000",
                      fontSize: "11px",
                    }}
                  >
                    Boost Review Score
                  </MDBox>
                </MDTypography>
              </MDBox>

              <MDBox
                sx={{
                  zIndex: 2,
                  width: "130px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: {
                    xs: "center",
                    sm: "start",
                  },
                  justifyContent: "space-between",
                }}
                mr={2}
                mb={2}
              >
                <MDBox>
                  <img
                    src={Group6}
                    alt="tick icon"
                    style={{
                      width: "38px",
                      height: "38px",
                      objectFit: "contain",
                    }}
                  />
                </MDBox>
                <MDTypography
                  sx={{
                    // fontWeight: "600",
                    lineHeight: "17px",
                    fontSize: "10px",
                    color: "#000",
                    fontFamily: "Poppins",
                  }}
                >
                  {" "}
                  <MDBox
                    sx={{
                      fontWeight: 500,
                      color: "#000",
                      fontSize: "11px",
                    }}
                  >
                    Grow Revenue
                  </MDBox>
                </MDTypography>
              </MDBox>

              <MDBox
                sx={{
                  zIndex: 2,
                  width: "130px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: {
                    xs: "center",
                    sm: "start",
                  },
                  justifyContent: "space-between",
                }}
                mr={2}
                mb={2}
                mt={0}
              >
                <MDBox>
                  <img
                    src={Group8}
                    alt="tick icon"
                    style={{
                      width: "38px",
                      height: "38px",
                      objectFit: "contain",
                    }}
                  />
                </MDBox>
                <MDTypography
                  sx={{
                    mb: 0.5,
                    // fontWeight: 700,
                    lineHeight: "17px",
                    fontSize: "10px",
                    color: "#000",
                    fontFamily: "Poppins",
                  }}
                >
                  {" "}
                  <MDBox
                    sx={{
                      fontWeight: 500,
                      color: "#000",
                      fontSize: "11px",
                    }}
                  >
                    Grow Customer Base
                  </MDBox>
                </MDTypography>
              </MDBox>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDBox>
    </MDBox>
  );
}

export default MainSection;
